import { render, staticRenderFns } from "./itemAlumno.vue?vue&type=template&id=2fb6240a&scoped=true&"
import script from "./itemAlumno.vue?vue&type=script&lang=js&"
export * from "./itemAlumno.vue?vue&type=script&lang=js&"
import style0 from "./itemAlumno.vue?vue&type=style&index=0&id=2fb6240a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb6240a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VRow,VTooltip})
